/* eslint-disable no-use-before-define */
import React from 'react'
import {format, arrayFrom} from '../../../twd'

export default (props) => {
    let { active, payload, coordinate } = props
    let { x } = coordinate
    if (!active || !x) return null

    let a = arrayFrom(payload)[0]
    if (!a) return null
    let p = a.payload
    if (!p || !p.benchmark) return null

    return renderBenchmarksTooltip({...props, payload:p})
}


const renderBenchmarksTooltip = ({
    colors,
    benchmarks,
    selectedBenchmarks,
    benchmarksData,
    payload
}) => {
    let data = benchmarks.map((b,i) => ({
        name: b,
        selected: selectedBenchmarks.indexOf(b)>=0,
        color: colors[i]
    }))
    .filter(b => b.selected)
    .map(b => {
        let arr = benchmarksData[b.name]
        if (!arr) return null

        let a = arr.find(n => n.x === payload.x)
        if (!a) return null

        b.data = a
        return b
    })
    .filter(Boolean)

    return <div style={{
        border: '1px solid #eaeaea',
        backgroundColor: '#fff',
        padding: '5px',
    }}>
    <table><tbody><tr>
        <td className="text-bold">{formatDuration(payload.x)} &nbsp; </td>
        {
        data.map((a,i) => <td
            key={i+1}
            className="label-small"
            style={{
                borderLeft: '4px solid ' + a.color,
                paddingLeft: '5px',
                paddingRight: '10px',
            }}>{a.name}<br/>
            <label className="label-large text-bold">{format.ytw(a.data.y)}%</label></td>
        )
    }
    </tr></tbody></table>
    </div>

}

const formatDuration = (x) => (x<1.0 ? ((x * 10) + ' Month') : (x+' Year') )



// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/benchmark/tooltip-content.js